var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePodcastIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-podcast-icon 1",
    clipPath: "url(#clip0_41_354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 46.5901V53.4097C12.5 56.8603 9.70052 59.6597 6.25 59.6597C2.79948 59.6597 0 56.8603 0 53.4097V46.5901C0 43.1396 2.79948 40.3401 6.25 40.3401C9.70052 40.3401 12.5 43.1396 12.5 46.5901Z",
    fill: "#0066D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M87.5 46.7691C87.5 46.7122 87.5 46.6471 87.5 46.5901C87.5 43.1396 90.2995 40.3401 93.75 40.3401C97.2005 40.3401 100 43.1396 100 46.5901C100 46.6471 100 46.7122 100 46.7691V53.5888C99.9023 56.9579 97.1436 59.6597 93.75 59.6597C90.3564 59.6597 87.5977 56.9579 87.5 53.5888V46.7691Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M34.0898 67.0492V73.8689C34.0898 77.3194 31.2904 80.1189 27.8398 80.1189C24.3893 80.1189 21.5898 77.3194 21.5898 73.8689V67.0492C21.5898 63.5987 24.3893 60.7992 27.8398 60.7992C31.2904 60.7992 34.0898 63.5906 34.0898 67.0492ZM34.0898 26.1394V48.4376C34.0166 51.823 31.2497 54.5492 27.8398 54.5492C24.4381 54.5492 21.6712 51.8311 21.5898 48.4376V26.1394C21.5898 22.6889 24.3893 19.8894 27.8398 19.8894C31.2904 19.8894 34.0898 22.6807 34.0898 26.1394Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M65.9102 32.9508C65.9102 36.4013 68.7096 39.2008 72.1602 39.2008C75.6107 39.2008 78.4102 36.4013 78.4102 32.9508V26.1311C78.4102 22.6806 75.6107 19.8811 72.1602 19.8811C68.7096 19.8811 65.9102 22.6806 65.9102 26.1311V32.9508Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M43.75 13.0697C43.75 16.5202 46.5495 19.3197 50 19.3197C53.4505 19.3197 56.25 16.5202 56.25 13.0697V6.25C56.25 2.79948 53.4505 0 50 0C46.5495 0 43.75 2.79948 43.75 6.25V13.0697ZM43.75 86.9303C43.75 83.4798 46.5495 80.6803 50 80.6803C53.4505 80.6803 56.25 83.4798 56.25 86.9303V93.75C56.25 97.2005 53.4505 100 50 100C46.5495 100 43.75 97.2005 43.75 93.75V86.9303Z",
    fill: "#FAB908"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M65.9102 51.7009C65.9102 48.2504 68.7096 45.4509 72.1602 45.4509C75.6107 45.4509 78.4102 48.2504 78.4102 51.7009V73.8608C78.4102 77.3113 75.6107 80.1108 72.1602 80.1108C68.7096 80.1108 65.9102 77.3113 65.9102 73.8608V51.7009Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M56.25 31.8196V68.1803C56.25 71.6308 53.4505 74.4303 50 74.4303C46.5495 74.4303 43.75 71.6308 43.75 68.1803V31.8196C43.75 28.3691 46.5495 25.5696 50 25.5696C53.4505 25.5696 56.25 28.3691 56.25 31.8196Z",
    fill: "#FAB908"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePodcastIcon1);
export default __webpack_public_path__ + "static/media/google-podcast-icon-1.d316f9198aa8ac10db74acf04a9ee65c.svg";
export { ForwardRef as ReactComponent };